function initCustomRecommendedProducts(config) {
  var sectionId               = config.sectionId;
  var productId               = config.productId;
  var pageType                = config.pageType || 'fallback';
  var sourceCollectionHandle  = config.sourceCollectionHandle || '';   // explicitly selected in section settings
  var currentCollectionHandle = config.currentCollectionHandle || '';  // the page's own collection (URL)
  var productsToShow          = config.productsToShow || 4;
  var atcText                 = config.atcText || 'Add to Bag';
  var moneyFormat             = config.moneyFormat || '${{amount}}';
  var enableDesktopCarousel   = config.enableDesktopCarousel || false;
  var mobileLayout            = config.mobileLayout || 'slider';
  var mobileStackedCount      = config.mobileStackedCount || 3;

  var grid          = document.getElementById('crp-grid-' + sectionId);
  var dotsContainer = document.getElementById('crp-dots-' + sectionId);

  if (!grid) return;

  // A source collection counts as "configured" only when it was explicitly
  // selected in the section settings (passed as sourceCollectionHandle).
  var hasSourceCollection = sourceCollectionHandle && sourceCollectionHandle !== '';

  // Unlimited ONLY on a collection page that has NO configured source collection.
  // In that single case we show the whole collection. Everywhere else the
  // Product Count setting applies.
  var unlimited = (pageType === 'collection' && !hasSourceCollection);

  var isMobile = window.innerWidth <= 767;

  // When unlimited on mobile, force the stacked "browse all" mode.
  if (unlimited && isMobile) {
    mobileLayout       = 'stacked';
    mobileStackedCount = 999;
  }

  var effectiveProductsToShow;
  if (unlimited) {
    effectiveProductsToShow = 999;
  } else if (isMobile && mobileLayout === 'stacked') {
    effectiveProductsToShow = mobileStackedCount;
  } else {
    effectiveProductsToShow = productsToShow;
  }

  var sectionUrl = window.location.pathname + '?section_id=' + sectionId;

  fetch(sectionUrl)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser  = new DOMParser();
      var doc     = parser.parseFromString(html, 'text/html');
      var scripts = doc.querySelectorAll('script');
      scripts.forEach(function (s) {
        if (
          s.textContent.indexOf('crpBannerPricing') !== -1 ||
          s.textContent.indexOf('crpProductTags') !== -1 ||
          s.textContent.indexOf('crpNoRecommendHandles') !== -1
        ) {
          try { eval(s.textContent); } catch (e) {}
        }
      });
    })
    .catch(function () {})
    .then(function () {
      var excludedHandles = ['package-protection', 'gift-card', 'bonus-save-your-retainer-impressions', 'bonus-subscription'];
      var maxNeeded  = Math.max(productsToShow, mobileStackedCount);
      var fetchLimit = maxNeeded + excludedHandles.length + 10;

      // Resolve the current collection handle from the URL if it wasn't supplied.
      var collectionHandleFromUrl = currentCollectionHandle;
      if (!collectionHandleFromUrl) {
        var pathMatch = window.location.pathname.match(/\/collections\/([^\/]+)/);
        if (pathMatch && pathMatch[1]) collectionHandleFromUrl = pathMatch[1];
      }

      console.log('Page Type:', pageType);
      console.log('Source Collection:', sourceCollectionHandle);
      console.log('Current Collection:', collectionHandleFromUrl);
      console.log('Has Source Collection:', hasSourceCollection);
      console.log('Unlimited:', unlimited);

      var fetchPromise;

      if (pageType === 'collection') {
        if (hasSourceCollection) {
          // Configured source collection -> limited by Product Count.
          fetchPromise = fetchCollectionProducts(sourceCollectionHandle, '', fetchLimit);
        } else {
          // No source collection -> the page's own collection, show everything.
          fetchPromise = fetchCollectionProducts(collectionHandleFromUrl, '', 999);
        }
      }
      else if (pageType === 'product') {
        if (hasSourceCollection) {
          fetchPromise = fetchCollectionProducts(sourceCollectionHandle, productId, fetchLimit);
        } else if (productId && productId !== '') {
          fetchPromise = fetchRecommendations(productId, fetchLimit);
        } else if (collectionHandleFromUrl) {
          fetchPromise = fetchCollectionProducts(collectionHandleFromUrl, productId, fetchLimit);
        } else {
          fetchPromise = fetchFallbackProducts(fetchLimit);
        }
      }
      else {
        // Fallback page
        if (hasSourceCollection) {
          fetchPromise = fetchCollectionProducts(sourceCollectionHandle, productId, fetchLimit);
        } else {
          fetchPromise = fetchFallbackProducts(fetchLimit);
        }
      }

      return fetchPromise.then(function (products) {
        if (!products || products.length === 0) return [];

        var noRecommend = window.crpNoRecommendHandles || {};

        products = products.filter(function (p) {
          if (excludedHandles.indexOf(p.handle) !== -1) return false;
          if (noRecommend[p.handle]) return false;
          if (p.tags) {
            var tagsArr = Array.isArray(p.tags) ? p.tags : String(p.tags).split(',');
            for (var i = 0; i < tagsArr.length; i++) {
              if (tagsArr[i].trim() === 'no-index') return false;
            }
          }
          return true;
        });

        // Unlimited -> return everything. Otherwise apply the Product Count.
        if (unlimited) {
          return products;
        }
        return products.slice(0, effectiveProductsToShow);
      });
    })
    .then(function (products) {
      if (!products || products.length === 0) return;

      grid.innerHTML = '';
      products.forEach(function (product) {
        grid.insertAdjacentHTML('beforeend', buildCardHTML(product, atcText, moneyFormat));
      });

      var currentMobile = window.innerWidth <= 767;
      if (currentMobile && mobileLayout === 'stacked') {
        grid.classList.add('crp-stacked-mobile');
        grid.classList.remove('crp-slick-enabled');
      } else {
        grid.classList.remove('crp-stacked-mobile');
        initSlickSlider(grid, sectionId, effectiveProductsToShow, enableDesktopCarousel, mobileLayout);
      }

      attachAtcListeners(grid, atcText);
      attachSwatchClickListeners(grid);

      handleResizeLayout(grid, sectionId, productsToShow, mobileStackedCount, mobileLayout, enableDesktopCarousel, atcText, moneyFormat);
    })
    .catch(function (err) {
      console.warn('[Products Recommended] failed:', err);
    });
}


function handleResizeLayout(grid, sectionId, productsToShow, mobileStackedCount, mobileLayout, enableDesktopCarousel, atcText, moneyFormat) {
  var resizeTimer;
  var lastIsMobile = window.innerWidth <= 767;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var nowMobile = window.innerWidth <= 767;

      if (nowMobile === lastIsMobile) return;
      lastIsMobile = nowMobile;

      if (nowMobile && mobileLayout === 'stacked') {
        if (typeof jQuery !== 'undefined') {
          var $grid = jQuery('#crp-grid-' + sectionId);
          if ($grid.hasClass('slick-initialized')) {
            $grid.slick('unslick');
          }
        }
        grid.classList.add('crp-stacked-mobile');
        grid.classList.remove('crp-slick-enabled');

        var cards = grid.querySelectorAll('.crp-card');
        cards.forEach(function (card, idx) {
          card.style.display = idx < mobileStackedCount ? '' : 'none';
        });
      } else {
        grid.classList.remove('crp-stacked-mobile');
        var cards = grid.querySelectorAll('.crp-card');
        cards.forEach(function (card) {
          card.style.display = '';
        });
        initSlickSlider(grid, sectionId, productsToShow, enableDesktopCarousel, mobileLayout);
      }
    }, 250);
  });
}

function initSlickSlider(grid, sectionId, productsToShow, enableDesktopCarousel, mobileLayout) {
  var isMobile = window.innerWidth <= 767;

  if (isMobile && mobileLayout === 'stacked') {
    grid.classList.remove('crp-slick-enabled');
    return;
  }

  if (!isMobile && !enableDesktopCarousel) {
    grid.classList.remove('crp-slick-enabled');
    return;
  }

  function loadScript(src, cb) {
    if (document.querySelector('script[src="' + src + '"]')) { cb(); return; }
    var s = document.createElement('script');
    s.src = src;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function loadCSS(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel  = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  loadCSS('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css');
  loadCSS('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css');

  function initSlick() {
    if (typeof jQuery === 'undefined') return;

    var $grid = jQuery('#crp-grid-' + sectionId);

    if ($grid.hasClass('slick-initialized')) {
      $grid.slick('unslick');
    }

    grid.classList.add('crp-slick-enabled');

    var desktopSlides = productsToShow > 4 ? 4 : productsToShow;

    $grid.slick({
    slidesToShow  : desktopSlides,
    slidesToScroll: 1,
    infinite      : true,
    arrows        : true,
    dots          : false,
    speed         : 400,
    cssEase       : 'ease',

    // ✅ Custom Chevron Arrows
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left-icon lucide-arrow-left"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right-icon lucide-arrow-right"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></button>',

    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 768,  settings: { slidesToShow: 2, dots: true, arrows: false } },
      { breakpoint: 576,  settings: { slidesToShow: 1, dots: true, arrows: false } }
    ]
  });
  }

  function ensureJQueryThenSlick() {
    if (typeof jQuery === 'undefined') {
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js', function () {
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js', function () {
          initSlick();
        });
      });
    } else {
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js', function () {
        initSlick();
      });
    }
  }

  ensureJQueryThenSlick();
}

function fetchRecommendations(productId, limit) {
  var apiUrl = '/recommendations/products.json?product_id=' + productId
             + '&limit=' + limit
             + '&intent=related';

  return fetch(apiUrl)
    .then(function (res) {
      if (!res.ok) throw new Error('API error ' + res.status);
      return res.json();
    })
    .then(function (data) {
      var products = data.products;
      if (!products || products.length === 0) {
        return fetchFallbackProducts(limit);
      }
      return normalizeProductPrices(products, true);
    });
}

function fetchFallbackProducts(limit) {
  return fetch('/collections/all/products.json?limit=' + (limit + 5))
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var products = (data.products || []).map(function (p) {
        if (!p.url) p.url = '/products/' + p.handle;
        return p;
      });
      return normalizeProductPrices(products, false).slice(0, limit);
    })
    .catch(function () { return []; });
}

function fetchCollectionProducts(handle, currentProductId, limit) {
  if (!handle) return Promise.resolve([]);

  return fetch('/collections/' + handle + '/products.json?limit=' + (limit + 5))
    .then(function (res) {
      if (!res.ok) throw new Error('Collection fetch error ' + res.status);
      return res.json();
    })
    .then(function (data) {
      var products = (data.products || [])
        .filter(function (p) {
          if (!currentProductId || currentProductId === '') return true;
          return String(p.id) !== String(currentProductId);
        })
        .map(function (p) {
          if (!p.url) p.url = '/products/' + p.handle;
          return p;
        });

      if (handle === 'best-sellers') {
        var pinnedHandle = 'custom-night-guard';
        var pinnedIndex  = products.findIndex(function (p) {
          return p.handle === pinnedHandle;
        });
        if (pinnedIndex > 0) {
          var pinnedProduct = products.splice(pinnedIndex, 1)[0];
          products.unshift(pinnedProduct);
        }
      }

      return normalizeProductPrices(products, false).slice(0, limit);
    })
    .catch(function () { return []; });
}

function normalizeProductPrices(products, fromCents) {
  return products.map(function (p) {
    if (p.variants) {
      p.variants = p.variants.map(function (v) {
        if (!fromCents) {
          var price          = parseFloat(v.price) || 0;
          var compareAtPrice = parseFloat(v.compare_at_price) || 0;
          v.price            = String(Math.round(price * 100));
          v.compare_at_price = compareAtPrice > 0 ? String(Math.round(compareAtPrice * 100)) : null;
        }
        return v;
      });
    }
    return p;
  });
}

function getPrices(product) {
  var map       = window.crpBannerPricing || {};
  var handle    = product.handle || '';
  var bannerVal = map[handle];

  var variant        = product.variants && product.variants[0];
  var productPrice   = variant ? parseInt(variant.price, 10) : 0;
  var compareAtPrice = variant && variant.compare_at_price
    ? parseInt(variant.compare_at_price, 10)
    : 0;

  if (bannerVal !== undefined && bannerVal !== null && String(bannerVal).trim() !== '') {
    var bannerNum = parseFloat(bannerVal);
    if (!isNaN(bannerNum) && bannerNum > 0) {
      return {
        salePrice    : Math.round(bannerNum * 100),
        comparePrice : productPrice
      };
    }
  }

  if (compareAtPrice > 0 && compareAtPrice > productPrice) {
    return {
      salePrice    : productPrice,
      comparePrice : compareAtPrice
    };
  }

  return {
    salePrice    : Math.round(productPrice * 50 / 100),
    comparePrice : productPrice
  };
}

function buildColorSwatches(product) {
  if (!product.options || !product.variants) return '';

  var colorOptionIndex = -1;
  product.options.forEach(function (opt, i) {
    var name = (typeof opt === 'object' ? opt.name : opt) || '';
    if (/colou?r|rang|rung/i.test(name)) colorOptionIndex = i;
  });

  if (colorOptionIndex === -1) return '';

  var seen     = {};
  var swatches = [];

  product.variants.forEach(function (v) {
    var colorVal = v['option' + (colorOptionIndex + 1)];
    if (!colorVal || seen[colorVal]) return;
    seen[colorVal] = true;

    var img1 = null;
    var img2 = null;

    if (v.featured_image && v.featured_image.src) {
      img1 = v.featured_image.src;
      if (product.images) {
        var pos     = v.featured_image.position;
        var nextImg = product.images.find(function (im) {
          return im.position === pos + 1;
        });
        img2 = nextImg ? (nextImg.src || nextImg) : null;
      }
    }

    if (!img1 && product.images && product.images[0]) {
      img1 = product.images[0].src || product.images[0];
    }
    if (!img2 && product.images && product.images[1]) {
      img2 = product.images[1].src || product.images[1];
    }

    swatches.push({ color: colorVal, img1: img1 || '', img2: img2 || '', variantId: v.id });
  });

  if (swatches.length === 0) return '';

  var maxVisible = 6;
  var visible    = swatches.slice(0, maxVisible);
  var extraCount = swatches.length - maxVisible;

  var dots = visible.map(function (sw, idx) {
    var cssColor = resolveColor(sw.color);
    return (
      '<span '
      + 'class="crp-swatch' + (idx === 0 ? ' is-active' : '') + '" '
      + 'data-img1="' + escHtml(sw.img1) + '" '
      + 'data-img2="' + escHtml(sw.img2) + '" '
      + 'data-variant-id="' + sw.variantId + '" '
      + 'style="background-color:' + cssColor + ';" '
      + 'title="' + escHtml(sw.color) + '" '
      + 'aria-label="' + escHtml(sw.color) + '" '
      + 'role="button" tabindex="0">'
      + '</span>'
    );
  }).join('');

  var extraHTML = extraCount > 0
    ? '<span class="crp-swatch-extra">+' + extraCount + '</span>'
    : '';

  return '<div class="crp-swatches">' + dots + extraHTML + '</div>';
}

function resolveColor(name) {
  var map = {
    'pearl': '#fff', 'charcoal': '#000', 'ivory': '#fffff0',
    'champagne': '#f7e7ce', 'rose': '#ff007f', 'rosegold': '#b76e79',
    'rose gold': '#b76e79', 'sand': '#c2b280', 'nude': '#e3bc9a',
    'blush': '#de5d83', 'slate': '#708090', 'stone': '#928e85',
    'mint': '#98ff98', 'sage': '#b2ac88', 'forest': '#228b22',
    'navy': '#001f5b', 'cobalt': '#0047ab', 'sky': '#87ceeb',
    'denim': '#1560bd', 'mustard': '#ffdb58', 'camel': '#c19a6b',
    'tan': '#d2b48c', 'rust': '#b7410e', 'terracotta': '#e2725b',
    'burgundy': '#800020', 'wine': '#722f37', 'mauve': '#e0b0ff',
    'lilac': '#c8a2c8', 'lavender': '#e6e6fa', 'plum': '#8e4585',
    'smoke': '#738276', 'ash': '#b2beb5', 'bone': '#e3dac9',
    'cream': '#fffdd0', 'ecru': '#c2b280', 'natural': '#f5f0e8',
    'oatmeal': '#d4c5a9', 'espresso': '#3b1f0f', 'mocha': '#6f4e37',
    'chocolate': '#7b3f00', 'cognac': '#9a463d', 'gold': '#ffd700',
    'bronze': '#cd7f32', 'copper': '#b87333', 'silver': '#c0c0c0',
    'graphite': '#474a51', 'gunmetal': '#2a3439', 'onyx': '#353839',
    'jet': '#343434', 'obsidian': '#3d3635', 'arctic': '#e8f4f8',
    'glacier': '#cce8e8', 'ocean': '#006994', 'teal': '#008080',
    'jade': '#00a36c', 'emerald': '#50c878', 'fern': '#4f7942',
    'olive': '#808000', 'moss': '#8a9a5b', 'coral': '#ff6b6b',
    'peach': '#ffcba4', 'apricot': '#fbceb1', 'mango': '#fdbe02',
    'lemon': '#fff44f', 'buttercup': '#f3ad16', 'amber': '#ffbf00',
    'scarlet': '#ff2400', 'crimson': '#dc143c', 'cherry': '#de3163',
    'watermelon': '#fc6c85', 'bubblegum': '#ff69b4', 'hot pink': '#ff69b4',
    'hotpink': '#ff69b4', 'fuchsia': '#ff00ff', 'magenta': '#ff00ff',
    'violet': '#ee82ee', 'indigo': '#4b0082', 'midnight': '#191970',
    'dusk': '#4e5b6e', 'storm': '#4f666a', 'fog': '#d4d4d4',
    'cloud': '#f0f0f0', 'snow': '#fffafa', 'chalk': '#f5f5f5',
    'off-white': '#faf9f6', 'offwhite': '#faf9f6'
  };
  var key = name.toLowerCase().trim();
  if (map[key]) return map[key];
  return key.replace(/\s+/g, '');
}

function updateCardImages(card, swatch) {
  var img1Src = swatch.getAttribute('data-img1');
  var img2Src = swatch.getAttribute('data-img2');

  var primaryImg = card.querySelector('.crp-image--primary');
  if (primaryImg && img1Src) primaryImg.src = img1Src;

  var secondaryImg = card.querySelector('.crp-image--secondary');
  if (secondaryImg) {
    if (img2Src) {
      secondaryImg.src = img2Src;
      secondaryImg.style.display = '';
    } else {
      secondaryImg.style.display = 'none';
    }
  }
}

function attachSwatchClickListeners(grid) {

  // CLICK → image + active state + variant id update
  grid.addEventListener('click', function (e) {
    var swatch = e.target.closest('.crp-swatch');
    if (!swatch) return;

    var card = swatch.closest('.crp-card');
    if (!card) return;

    updateCardImages(card, swatch);

    card.querySelectorAll('.crp-swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    var form = card.querySelector('.crp-atc-form');
    if (form) {
      var variantId = swatch.getAttribute('data-variant-id');
      if (variantId) form.setAttribute('data-variant-id', variantId);
    }
  });

  grid.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.crp-swatch');
    if (!swatch) return;

    var card = swatch.closest('.crp-card');
    if (!card) return;

    updateCardImages(card, swatch);
  });

  grid.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.crp-swatch');
    if (!swatch) return;

    var relatedSwatch = e.relatedTarget && e.relatedTarget.closest('.crp-swatch');
    var card = swatch.closest('.crp-card');
    if (relatedSwatch && relatedSwatch.closest('.crp-card') === card) return;

    if (!card) return;

    var activeSwatch = card.querySelector('.crp-swatch.is-active');
    if (activeSwatch) updateCardImages(card, activeSwatch);
  });

  // KEYBOARD (existing)
  grid.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var swatch = e.target.closest('.crp-swatch');
      if (swatch) { e.preventDefault(); swatch.click(); }
    }
  });
}

function buildCardHTML(product, atcText, moneyFormat) {
  var variant   = product.variants && product.variants[0];
  var variantId = variant ? variant.id : '';
  var sellingPlanMap = window.crpSellingPlans || {};
  var sellingPlanId  = sellingPlanMap[product.handle || ''] || '';

  var productUrl = product.url || ('/products/' + product.handle);

  var prices       = getPrices(product);
  var salePrice    = prices.salePrice;
  var comparePrice = prices.comparePrice;

  var primaryImg   = null;
  var secondaryImg = null;

  if (product.featured_image && product.featured_image.src) {
    primaryImg = product.featured_image.src;
  } else if (product.images && product.images[0]) {
    primaryImg = typeof product.images[0] === 'string'
      ? product.images[0]
      : product.images[0].src || product.images[0];
  }

  if (product.images && product.images[1]) {
    secondaryImg = typeof product.images[1] === 'string'
      ? product.images[1]
      : product.images[1].src || product.images[1];
  }

  function fmt(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) return '';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var amountInt = Math.round(cents / 100);
    return moneyFormat
      .replace(/\{\{amount\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, amountInt)
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount.replace('.', ','))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, amountInt);
  }

  var imgHTML = primaryImg
    ? '<img src="' + primaryImg + '" alt="' + escHtml(product.title) + '" class="crp-image crp-image--primary" loading="lazy">'
      + (secondaryImg
          ? '<img src="' + secondaryImg + '" alt="' + escHtml(product.title) + '" class="crp-image crp-image--secondary" loading="lazy">'
          : '')
    : '<div class="crp-image-placeholder"><svg viewBox="0 0 24 24" fill="none"><rect width="24" height="24" fill="#f3f4f6"/><path d="M4 16l4-4 4 4 4-6 4 6" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8.5" cy="8.5" r="1.5" fill="#d1d5db"/></svg></div>';

  var priceHTML = '<span class="crp-price crp-price--compare">' + fmt(comparePrice) + '</span>'
                + '<span class="crp-price crp-price--sale">'    + fmt(salePrice)    + '</span>';

  var swatchesHTML = buildColorSwatches(product);

  var tagsMap     = window.crpProductTags || {};
  var productTags = tagsMap[product.handle || ''] || '';
  var tagsHTML    = (!swatchesHTML && productTags)
    ? '<div class="crp-product-tags"><span>' + escHtml(productTags) + '</span></div>'
    : '';

  return (
    '<div class="crp-card">'
    + '<div class="crp-image-wrapper">'
    +   '<a href="' + productUrl + '" class="crp-image-link" aria-label="' + escHtml(product.title) + '">'
    +     imgHTML
    +   '</a>'
    +   '<div class="crp-card-actions">'
    +     '<form class="crp-atc-form" data-variant-id="' + variantId + '"' + (sellingPlanId ? ' data-selling-plan="' + sellingPlanId + '"' : '') + '>'
    +       '<button type="submit" class="crp-btn-atc">' + escHtml(atcText) + '</button>'
    +     '</form>'
    +     '<a href="' + productUrl + '" class="crp-btn-view" aria-label="View ' + escHtml(product.title) + '">'
    +       '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M25 22H23V10.4141L8.70703 24.707L7.29297 23.293L21.5859 9H10V7H25V22Z" fill="#009CCC"/></svg>'
    +     '</a>'
    +   '</div>'
    + '</div>'
    + '<div class="crp-card-info">'
    +   swatchesHTML
    +   tagsHTML
    +   '<div class="crp-title-price-wrapper">'
    +     '<h3 class="crp-product-title"><a href="' + productUrl + '">' + escHtml(product.title) + '</a></h3>'
    +     '<div class="crp-prices">' + priceHTML + '</div>'
    +   '</div>'
    + '</div>'
    + '</div>'
  );
}

function buildDots(container, count, grid) {
  if (!container || count < 2) return;
  container.innerHTML = '';

  for (var i = 0; i < count; i++) {
    var btn = document.createElement('button');
    btn.className = 'crp-dot' + (i === 0 ? ' is-active' : '');
    btn.setAttribute('data-index', i);
    btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    container.appendChild(btn);
  }

  container.addEventListener('click', function (e) {
    var dot = e.target.closest('.crp-dot');
    if (!dot) return;
    var idx   = parseInt(dot.getAttribute('data-index'), 10);
    var cards = grid.querySelectorAll('.crp-card');
    if (!cards[idx]) return;
    var cardW = cards[0].offsetWidth + 12;
    grid.scrollTo({ left: idx * cardW, behavior: 'smooth' });
  });

  var timer;
  grid.addEventListener('scroll', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (window.innerWidth > 767) return;
      var cards = grid.querySelectorAll('.crp-card');
      if (!cards.length) return;
      var cardW  = cards[0].offsetWidth + 12;
      var active = Math.round(grid.scrollLeft / cardW);
      container.querySelectorAll('.crp-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }, 60);
  });
}

function attachAtcListeners(grid, atcText) {
  grid.addEventListener('submit', function (e) {
    var form = e.target.closest('.crp-atc-form');
    if (!form) return;
    e.preventDefault();

    var btn       = form.querySelector('.crp-btn-atc');
    var variantId   = form.getAttribute('data-variant-id');
    var sellingPlan = form.getAttribute('data-selling-plan');
    if (!variantId) return;

    btn.textContent = 'Adding…';
    btn.disabled    = true;

    var payload = { id: variantId, quantity: 1 };
    if (sellingPlan && sellingPlan !== '') payload.selling_plan = sellingPlan;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (bodyText) {
            console.warn('CRP add to cart failed', res.status, bodyText);
            throw new Error('cart error');
          });
        }
        return res.json();
      })
      .then(function () {
        btn.textContent      = 'Added ✓';
        btn.style.background = '#009CCC';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(function () {
          btn.textContent      = atcText;
          btn.style.background = '';
          btn.disabled         = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent      = 'Try again';
        btn.style.background = '#009CCC';
        btn.disabled         = false;
        setTimeout(function () {
          btn.textContent      = atcText;
          btn.style.background = '';
        }, 2000);
      });
  });
}

function escHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
